import React, {useEffect} from "react";
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";



// components
import NotificationForm from "./_form";
import NotificationFilters from "./_filters";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import {GenericButton} from "../../../components/buttons/customButtons";

// labels
import {TT_DELETE, TT_EDIT, TT_SEND_ALERT} from "../../../components/i18n/toolTips";
import {
    ARE_YOU_SHURE_TITLE,
    LB_ACTIONS,
    LB_CODE,
    LB_TITLE, LB_YES_SEND_ALERT,
    LIST, NO,
    NO_DATA_FOUND, YOU_SHURE_SEND_ALERT
} from "../../../components/i18n/i18n";

// actions
import { setFilter, setTableParams, setForm, setItem } from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services
import {notificationsService} from "../../../jwt/_services/comunication/notificationsService";

// utils
import {getStateByPath} from "../../../redux/selectors";
import {FL_BODY} from "../../../components/i18n/formLabels";
import {confirmAlert} from "react-confirm-alert";




const NotificationLists = (props) => {
    const {path} = props
    const componentState = useSelector(state => getStateByPath(state, path));
    const {userIsAdmin, app, udn, pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};

    const {fbDataBase} = app

    useEffect( () => {
        if(filter)
            return

        props.setFilter(path, {
            fbDataBase,
            item: { code: null }
        })
    }, [app]);


    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, notificationsService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);


    const editItem = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);

        ModalFormContainer(NotificationForm, { path, data })
    }

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path)

        ModalFormContainer(NotificationForm, { path })
    }


    const confirmDelete = data => ConfirmDelete({
        path,
        data,
        fbDataBaseId: fbDataBase?.id,
        service: notificationsService,
        remove : genericIndexedActions.delete,
    } );

    const handleTableChange = (type, {page, sizePerPage}) => {
        let currentIndex = (page - 1) * sizePerPage
        props.setTableParams(path, sizePerPage, currentIndex, totalSize, currentIndex )
    };


    const sendAlert = data => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) => <div className='custom-ui'>
            <h1>{ARE_YOU_SHURE_TITLE}</h1>
            <p>{YOU_SHURE_SEND_ALERT}</p>
            <button onClick={onClose}>{NO}</button>
            <button className={"btn-alert-delete"} onClick={() => {
                props.sendAlert({
                    header:{  app: props.mainProps?.app?.id, },
                    item:{ id: data?.id }
                })
                onClose();
            }}>
                {LB_YES_SEND_ALERT}
            </button>
        </div>
    });


    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        }, {
            dataField: 'code',
            text: `${LB_CODE}`,
            headerStyle: {width: '80px'}
        }, {
            dataField: 'title',
            text: `${LB_TITLE}`,
        }, {
            dataField: 'applicative',
            text:'Aplicación',
            formatter: (cell, row) => <>{row?.applicative?.name}</>
        },{
            dataField: 'udn',
            text: `Unidad de Negocio`,
            formatter: (cell, row) => <>{row?.udn?.title}</>
        }, {
            dataField: 'status',
            text: "Activo",
            headerStyle: {width: '30px'},
            headerAlign: 'center',
            align: 'center',
            formatter: (cell) => <ActiveFormatter active={cell}/>
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `${LB_ACTIONS}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '195px'},
            formatter: (cell, row) => <>
                <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
                <GenericTableButton toolTip={TT_SEND_ALERT} icon={'fa fa-paper-plane-o'} permission={'edit'} onClick={() => sendAlert(row)}/>
                <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
            </>
        }];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0 custom-card-title">
            <div>
                <i className="far fa-list-alt mr-2" />{'Lista de notificaciones'}
            </div>
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                    clazzName={'btn-list-card-title'}
                />
            </div>
        </CardTitle>

        <NotificationFilters path={path}/>

        <CardBody>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={ columns }
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={ handleTableChange }
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(NotificationLists);